import { useState } from 'react';

export type UseCharacterCountResult = {
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
};

export function useCharacterCount(): UseCharacterCountResult {
  const [isFocused, setIsFocused] = useState(false);
  return {
    isFocused,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
  };
}
